import { ApiResponse } from '@services/types'
import { axios } from '../../lib/axios'
import { ForgotPasswordResponse } from './types'

export interface ForgotPasswordRequest {
  username: string
}

export const forgotPassword = (
  data: ForgotPasswordRequest,
): Promise<ApiResponse<ForgotPasswordResponse>> => {
  return axios.post('/forgot-password', data)
}
